/* ProView — product page behaviour: gallery, bundle picker, add to cart, timer, sticky bar. */
(function () {
  'use strict';

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace('{{amount}}', parts.join('.'));
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-pv-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pv-thumb]'));
    if (!main || !thumbs.length) return;
    var i = 0;
    function show(n) {
      i = (n + thumbs.length) % thumbs.length;
      var t = thumbs[i];
      main.src = t.dataset.src;
      main.alt = t.dataset.alt || '';
      thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('[data-pv-prev]');
    var next = root.querySelector('[data-pv-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    var startX = null;
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
      startX = null;
    });
  }

  /* ---------- Buy box ---------- */
  function initBuyBox(root) {
    var fmt = root.dataset.moneyFormat || '${{amount}}';
    var currency = root.dataset.currency || '';
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-pv-option]'));
    var button = root.querySelector('[data-pv-atc]');
    var buttonText = button ? button.querySelector('[data-pv-atc-text]') : null;
    var errorEl = root.querySelector('[data-pv-error]');
    var addonQtyEl = root.querySelector('[data-pv-addon-qty]');
    var addonPrice = parseInt(root.dataset.addonPrice || '0', 10);
    var addonVariant = root.dataset.addonVariant || '';
    var priceNow = root.querySelector('[data-pv-price-now]');
    var priceWas = root.querySelector('[data-pv-price-was]');
    var priceSave = root.querySelector('[data-pv-price-save]');
    var state = { variant: null, price: 0, compare: 0, addonQty: 0 };

    function selected() { return options.filter(function (o) { return o.getAttribute('aria-checked') === 'true'; })[0]; }

    function render() {
      var o = selected();
      if (!o) return;
      state.variant = o.dataset.variantId;
      state.price = parseInt(o.dataset.price, 10);
      state.compare = parseInt(o.dataset.compare || '0', 10);
      var total = state.price + addonPrice * state.addonQty;
      if (buttonText) buttonText.textContent = money(total, fmt) + (currency ? ' ' + currency : '') + ' · ' + (root.dataset.atcLabel || 'ADD TO CART');
      if (priceNow) priceNow.textContent = money(state.price, fmt);
      if (priceWas) {
        if (state.compare > state.price) { priceWas.textContent = money(state.compare, fmt); priceWas.hidden = false; }
        else priceWas.hidden = true;
      }
      if (priceSave) {
        if (state.compare > state.price) {
          priceSave.textContent = (root.dataset.saveLabel || 'Save') + ' ' + Math.round((1 - state.price / state.compare) * 100) + '%';
          priceSave.hidden = false;
        } else priceSave.hidden = true;
      }
      if (addonQtyEl) addonQtyEl.textContent = state.addonQty;
      var sticky = document.querySelector('[data-pv-sticky-price]');
      if (sticky) sticky.textContent = money(state.price, fmt);
    }

    options.forEach(function (o) {
      o.addEventListener('click', function (e) {
        if (e.target.closest('select') || e.target.closest('button')) return;
        options.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        o.setAttribute('aria-checked', 'true');
        render();
      });
    });

    root.querySelectorAll('[data-pv-addon-inc]').forEach(function (b) {
      b.addEventListener('click', function () { state.addonQty = Math.min(3, state.addonQty + 1); render(); });
    });
    root.querySelectorAll('[data-pv-addon-dec]').forEach(function (b) {
      b.addEventListener('click', function () { state.addonQty = Math.max(0, state.addonQty - 1); render(); });
    });

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.classList.add('is-visible');
    }

    function addToCart() {
      var o = selected();
      if (!o || !state.variant) return;
      if (errorEl) errorEl.classList.remove('is-visible');
      var props = {};
      o.querySelectorAll('select[data-pv-pair]').forEach(function (s) { props[s.dataset.pvPair] = s.value; });
      var items = [{ id: parseInt(state.variant, 10), quantity: 1, properties: props }];
      if (addonVariant && state.addonQty > 0) items.push({ id: parseInt(addonVariant, 10), quantity: state.addonQty });

      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        body.sections_url = window.location.pathname;
        if (drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
      }

      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { showError(res.description || res.message || 'Could not add to cart.'); return; }
          if (drawer && drawer.renderContents && res.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () { showError('Could not add to cart. Please try again.'); })
        .finally(function () {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        });
    }

    if (button) button.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });
    render();
  }

  /* ---------- Countdown (evergreen, per browser session) ---------- */
  function initTimer(el) {
    var minutes = parseInt(el.dataset.minutes || '10', 10);
    var key = 'pv_timer_end';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    var now = Date.now();
    if (!end || end < now) { end = now + minutes * 60 * 1000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} }
    var clock = el.querySelector('[data-pv-clock]');
    function tick() {
      var left = Math.max(0, end - Date.now());
      if (left === 0) { end = Date.now() + minutes * 60 * 1000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} left = end - Date.now(); }
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      clock.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Sticky bar ---------- */
  function initSticky(bar) {
    var anchor = document.querySelector('#proview-buy');
    if (!anchor) return;
    document.body.classList.add('pv-has-sticky');
    function check() {
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0);
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ---------- Buy-now links scroll to the buy box ---------- */
  function initScrollLinks() {
    document.querySelectorAll('a[href="#proview-buy"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector('#proview-buy');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pv-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-pv-buybox]').forEach(initBuyBox);
    document.querySelectorAll('[data-pv-timer]').forEach(initTimer);
    document.querySelectorAll('[data-pv-sticky]').forEach(initSticky);
    initScrollLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
